import React, { useState, useRef, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "@fetch/axios";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useTranslation } from "@hooks/useTranslation";

const Component = () => {
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const navigationRef = useRef(null);
  const { lang } = useContext(LanguageCurrencyContext);
  const { translate } = useTranslation();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('/categories/header' + `?lang=`+lang);
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories', error);
      } finally {
        setLoadingCategories(false);
      }
    };
    fetchCategories();
  }, [lang]);


  useEffect(() => {
    const navigation = navigationRef.current;
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const updateSpacing = () => {
      // Preserve the existing page spacing and add the extra mobile rows.
      const extraHeight = mobileQuery.matches
        ? Math.max(0, navigation.getBoundingClientRect().height - 40)
        : 0;
      document.documentElement.style.setProperty('--navigation-extra-height', `${extraHeight}px`);
    };
    const observer = new ResizeObserver(updateSpacing);
    observer.observe(navigation);
    mobileQuery.addEventListener('change', updateSpacing);
    updateSpacing();

    return () => {
      observer.disconnect();
      mobileQuery.removeEventListener('change', updateSpacing);
      document.documentElement.style.removeProperty('--navigation-extra-height');
    };
  }, []);

  return (
    <nav className="Navigation" ref={navigationRef}>
      <ul>
        {loadingCategories ? <li aria-live="polite">Loading...</li> : (
          <>
            {categories.map((category) => (
              <li key={category.id}>
                <Link to={`/category/${category.uri}`}>
                  <span>{category.name}</span>
                </Link>
              </li>
            ))}
            <li key="nuestros-artistas">
              <Link to={`/${translate('categories.our_artists_uri')}`}>
                <span>{translate('categories.our_artists')}</span>
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Component;
